<template>
  <v-container fluid fill-height>
    <v-layout row wrap align-center>
      <v-flex
        xs12
        class="display-2 font-weight-light text-xs-center">
        <div
          class="display-4 font-weight-light text-xs-center grey--text mb-5">
          <i class="fas fa-cogs"></i>
        </div>
        <div>Sorry! An error occurred during the login process.</div>
      </v-flex>
      <v-flex
        xs12
        class="text-xs-center"
        >
        <v-btn
          color="info"
          href="mailto:hello@outfox.ai"
        >
          Contact Us
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'ErrorsHandling',
  props: {
    errors: {
      type: Array,
      default: () => []
    }
  }
}
</script>
